export const CP_CATEGORY = Object.freeze({
  common: 'Portal',
  mobileNavBar: 'mobile_navbar_bottom',
  contentCardDownload: 'content_card_download',
  signUpFlow: 'sign_up_flow',
  loginFlow: 'log_in_flow',
  loginHelpLanding: 'log_in_help_landing',
})

export const CP_EVENT = Object.freeze({
  clickBottombarOptions: 'click',
  clickOnWorkSheet: 'N_CLICKS_FICHAS',
  reportDownload: 'CANTIDAD_DESCARGAS_INFORMES',
  totalVideoCallClicks: 'CANTIDAD_BOTON_VIDEOLLAMADA',
  totalWorksheet: 'FICHAS_TRABAJO_DISPONIBLE',
  clickEvent: 'click',
  pageView: 'page_view',
  errorEvent: 'error',
})

export const CP_PAGE_VIEW = Object.freeze({
  pageViewErrorPage: 'PAGE_VIEW_ERROR_PAGE',
  pageViewHome: 'PAGE_VIEW_HOME',
  pageView: 'page_view',
  pageViewPost: (id: string) => `PAGE_VIEW_POST_${id}`,
  pageViewVideo: (id: string) => `PAGE_VIEW_VIDEO_${id}`,
  pageViewPodcast: (id: string) => `PAGE_VIEW_PODCAST_${id}`,
})

export const CP_EVENT_LABEL = Object.freeze({
  reportDownload: 'DOWNLOAD_REPORT_BUTTON',
  bottomBarMenu: 'BOTTOM_BAR_MENU',
})

export const VIDEO_CALL_PAGE_VIEW = Object.freeze({
  pageViewGetReady: 'PAGE_VIEW_GET_READY',
  pageViewPermissionsRequest: 'PAGE_VIEW_PERMISSIONS_REQUEST',
  pageViewVideoCallPreview: 'PAGE_VIEW_VIDEO_CALL_PREVIEW',
  pageViewVideoCallPlay: 'PAGE_VIEW_VIDEO_CALL_PLAY',
  pageViewPermissionsIssue: 'PAGE_VIEW_PERMISSIONS_ISSUE',
})

export const SIGN_UP_STEP_LABELS = Object.freeze({
  stepDni: 'step_dni',
  stepPassword: 'step_password',
  stepRgpdAgreement: 'step_RGPD_agreement',
  stepSuccess: 'step_success',
})

export const LOGIN_STEP_LABELS = Object.freeze({
  stepDniPassword: 'step_dni&password',
  stepSmsCode: 'step_sms_code',
  loginScreen: 'login_screen',
})

export const LOGIN_ERROR_LABELS = Object.freeze({
  dniPasswordError: (errorCode: string) =>
    `step_dni&password_error_${errorCode}`,
  smsCodeError: (errorCode: string) => `step_sms_code_error_${errorCode}`,
})

export const HELP_LABELS = Object.freeze({
  step0: 'step_0',
})

export const PAGE_PATHS = Object.freeze({
  login: '/auth/login',
  loginMfa: '/auth/login/mfa',
  signUpStep1: '/auth/sign-up/step-1',
  signUpStep2: '/auth/sign-up/step-2',
  signUpStep3: '/auth/sign-up/step-3',
  signUpStep4: '/auth/sign-up/step-4',
})

export const PAGE_TITLES = Object.freeze({
  loginForm: 'Login Form',
  loginMfa: 'Login MFA',
  loginScreen: 'Login Screen',
  signUpStep1: 'Sign Up Step 1',
  signUpStep2: 'Sign Up Step 2',
  signUpStep3: 'Sign Up Step 3',
  signUpStep4: 'Sign Up Step 4',
})

// Click event labels
export const LOGIN_CLICK_LABELS = Object.freeze({
  loginSubmit: 'login_submit',
  verifyMfaCode: 'verify_mfa_code',
  resendSmsCode: 'resend_sms_code',
  attemptLogin: 'attempt_login',
  verifyMfa: 'verify_mfa',
  loginSuccessful: 'login_successful',
})

export const SIGNUP_CLICK_LABELS = Object.freeze({
  submitDni: 'submit_dni',
  submitConsent: 'submit_consent',
  submitPassword: 'submit_password',
  goToLogin: 'go_to_login',
})
